import { render } from "./areaeco.vue?vue&type=template&id=483342b2&scoped=true"
import script from "./areaeco.vue?vue&type=script&lang=js"
export * from "./areaeco.vue?vue&type=script&lang=js"

import "./areaeco.vue?vue&type=style&index=0&id=483342b2&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483342b2"]])

export default __exports__